import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class F1120SchM3Service {

  constructor(private http: HttpClient) { }

  // 🚀 CRITICAL: Accept filterParams and rowData parameters (F7004 SUCCESS PATTERN)
  saveF1120SchM3Form(
    baseUrl: string,
    formData: any[],
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    
    // 🚀 CRITICAL: Use correct URL construction (baseUrl contains /gtw/)
    const url = `${baseUrl}/saveJsonObject?action_code=801vwi`;

    // Get trans_type_key from first form data item
    const trans_type_key = formData.length > 0 ? formData[0].trans_type_key : null;
    
    console.log('🔧 SERVICE DEBUG - formData length:', formData.length);
    console.log('🔧 SERVICE DEBUG - trans_type_key:', trans_type_key);
    console.log('🔧 SERVICE DEBUG - first item:', formData[0]);

    // 🚀 CRITICAL: Build AngularJS-compatible payload structure EXACTLY like original
    const jsonSettings = {
      "tax_year": rowData.TAX_YEAR || filterParams.tax_year,
      "scenario": rowData.SCENARIO || filterParams.scenario || "",
      "jcd_key": rowData.JCD_KEY || filterParams.jcd_key || "",
      "combination_key": rowData.COMBINATION_KEY || filterParams.combination_key,
      "trans_type_key": trans_type_key
    };

    // Wrap formData in proper structure expected by backend
    const jsonObj = [{
      "addrows": [],
      "editrows": formData,  // FIXED: Don't wrap formData in another array
      "removerows": []
    }];
    
    console.log('🔧 SERVICE DEBUG - jsonObj structure:', JSON.stringify(jsonObj, null, 2));

    let params = _.merge({}, globalService?.globalParams || {}, filterParams);
    params = _.extend({ jsonObj: JSON.stringify(jsonObj) }, params);
    params = _.extend({ jsonSettings: JSON.stringify(jsonSettings) }, params);
    params.process_name = 'F1120_SCHD_M3';
    params.combination_key = rowData.COMBINATION_KEY || filterParams.combination_key;
    params.trans_type_key = trans_type_key;

    // Add required fields as separate parameters (not in jsonSettings)
    params.tax_year = rowData.TAX_YEAR || filterParams.tax_year;
    params.scenario = rowData.SCENARIO || filterParams.scenario || "";
    params.jcd_key = rowData.JCD_KEY || filterParams.jcd_key || "";
    params.scenarioCode = rowData.SCENARIO_CODE || filterParams.scenarioCode || rowData.SCENARIO || filterParams.scenario || "";
    params.is_issue_key_enabled = "N";

    // 🚀 CRITICAL: Build checkLockedbj from rowData matching AngularJS format
    const checkLockedbj = [{
      "leid": rowData.LEID || rowData.SOURCE_LEID || "",
      "consol_group_key": String(rowData.CONSOL_GROUP_KEY || "1"),
      "combination_key": String(rowData.COMBINATION_KEY || filterParams.combination_key || "")
    }];
    params.checkLockedbj = JSON.stringify(checkLockedbj);

    // Add Schedule M3 specific parameters
    if (rowData.CONSOL_GROUP_TYPE) {
      params.group_type = rowData.CONSOL_GROUP_TYPE;
    }
    
    if (rowData.ENTITY_TYPE) {
      params.e_type = rowData.ENTITY_TYPE;
    }

    // 🚀 CRITICAL: Use application/x-www-form-urlencoded (NOT json)
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      urlEncoded.set(key, params[key]);
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };

    return this.http.post<any>(url, urlEncoded.toString(), httpOptions);
  }
}